import './timeseries_chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SurveyTimeseriesView extends Monitoring.Views.Charts.TimeseriesChartView
  valueField: 'count'
  chartOptions:
    yAxis:
      min: 0
    colors: ['#FFA500']

  initialize: (@options = {}) ->
    super(@options)

  addSeries: ->
    if @_dataIsEmpty()
      @$el.removeClass('processing')
    else
      query = @searchQuery.deepCopy()
      query.set('interval', @intervalParam)
      @_getSurveyData(query)
      return

  _dataIsEmpty: ->
    @facets['date'].count == 0

  _getSurveyData: (query) ->
    @ajaxCall(@apiUrl, query.toJSON(), (response) =>
      @addSerie(@title, response.values, 1)
    )
